const user = {
    namespaced:true,   //开启命名空间，建议开启
    state:{
        token: localStorage.getItem('token') || '',
        userinfo: JSON.parse(localStorage.getItem('userinfo'))||'',
    }
}

export default user